import { render } from "./CsvUploadModal.vue?vue&type=template&id=72b07179&scoped=true"
import script from "./CsvUploadModal.vue?vue&type=script&lang=js"
export * from "./CsvUploadModal.vue?vue&type=script&lang=js"

import "../tailwind.css?vue&type=style&index=0&id=72b07179&scoped=true&lang=css&external"
import "./CsvUploadModal.vue?vue&type=style&index=1&id=72b07179&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b07179"]])

export default __exports__